import CustomAdsAdapter from './npawAdapters/customAdsAdapter';
import ShakaAdapter from './npawAdapters/shakaAdapter';

const NpawPluginAdapters = {
  ShakaAdapter: ShakaAdapter,
  CustomAdsAdapter: CustomAdsAdapter,
};

export default NpawPluginAdapters;
